var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, bindable, ViewResources, TemplatingEngine } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
var DynamicView = /** @class */ (function () {
    function DynamicView(element, resourcesExisting, templatingEngine) {
        this.element = element;
        this.resourcesExisting = resourcesExisting;
        this.templatingEngine = templatingEngine;
        this.shouldCache = false;
    }
    DynamicView.prototype.bindingContextChanged = function (newValue, oldValue) {
        if (this.content && this._binded) {
            this.processContentChange(false);
        }
    };
    DynamicView.prototype.contentChanged = function (newValue, oldValue) {
        if (!this._attached) {
            return;
        }
        if (this.content && this._binded) {
            this.processContentChange(true);
        }
    };
    DynamicView.prototype.attached = function () {
        this._attached = true;
        if (this.content && this._binded) {
            this.processContentChange(false);
            var loadedEvent = new CustomEvent("loaded", { detail: { value: this }, bubbles: true });
            this.element.dispatchEvent(loadedEvent);
        }
    };
    DynamicView.prototype.bind = function () {
        this._binded = true;
        if (this._binded && this.content) {
            this.processContentChange(true);
        }
    };
    DynamicView.prototype.processContentChange = function (contentChanged) {
        var element = this.element;
        if (this.view && this.shouldCache && !contentChanged) {
            if (this.view) {
                this.view.unbind();
                this.view.bindingContext = this.bindingContext;
                this.view.overrideContext = this.overrideContext;
                this.view.bind(this.bindingContext, this.overrideContext, true);
            }
            return;
        }
        var mainSlot = element.getElementsByClassName('main-slot').item(0);
        var div = document.createElement("div");
        div.classList.add("main-slot-child");
        mainSlot.innerHTML = "";
        mainSlot.appendChild(div);
        if (typeof this.content === "string") {
            div.innerHTML = this.content;
        }
        else if (typeof this.content === "object") {
            div.appendChild(this.content);
        }
        else {
            throw "content can be only a string or a HTMLElement";
        }
        if (this.view) {
            this.view.unbind();
            this.view.detached();
        }
        this.view = this.templatingEngine.enhance({
            element: div, bindingContext: this.bindingContext,
            overrideContext: this.overrideContext, resources: this.resources ? this.resources : this.resourcesExisting
        });
        this.view.attached();
        this.view.bind(this.bindingContext, this.overrideContext);
    };
    DynamicView.prototype.unbind = function () {
        if (this.view) {
            this.view.unbind();
            this.view.fragment = null;
            this.view.container = null;
            this.view = null;
            this._binded = false;
        }
    };
    DynamicView.prototype.detached = function () {
        var element = this.element;
        var mainSlot = element.getElementsByClassName('main-slot').item(0);
        var unloadedEvent = new CustomEvent("unloaded", { detail: { value: null }, bubbles: true });
        this.element.dispatchEvent(unloadedEvent);
        if (this.view) {
            this.view.detached();
            this.view.removeNodes();
            mainSlot.innerHTML = "";
            ;
        }
        this._attached = false;
    };
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], DynamicView.prototype, "content", void 0);
    __decorate([
        bindable,
        __metadata("design:type", ViewResources)
    ], DynamicView.prototype, "resources", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], DynamicView.prototype, "shouldCache", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], DynamicView.prototype, "bindingContext", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], DynamicView.prototype, "overrideContext", void 0);
    DynamicView = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Element,
            ViewResources,
            TemplatingEngine])
    ], DynamicView);
    return DynamicView;
}());
export { DynamicView };
